import React from "react"
import { MDXProvider } from "@mdx-js/react"
import Button from '@material-ui/core/Button';
import { navigate } from "gatsby"

import {
  safelyGetFrontMatter,
  withFallback,
  CMS_COMPONENTS,
  CMS_SHORTCODES,
} from "../cms"
import { SEO, Heading } from "../components"
import { RenderMarkdown } from "../core"

export const LeifArticleTemplate = ({ title, body, children, location }) => {
  return (
    <article>
      <SEO title={withFallback(title, "")} />
      {
        location.state && location.state.leifInteractive &&
        <Button className="leif-back-button" variant="contained" color="primary" onClick={() => navigate(location.state.leifInteractive, { state: { visitedCities: location.state.visitedCities || []}})}>Back</Button>
      }
      <Heading tag={1}>{title}</Heading>
      {/* If children should be used instead of body, body will be empty, so it's safe to have both */}
      <RenderMarkdown md={body} />
      {/* Include children to support any normal MDX files in the project */}
      <MDXProvider components={{ ...CMS_COMPONENTS, ...CMS_SHORTCODES }}>
        {children}
      </MDXProvider>
    </article>
  )
}

const LeifArticle = ({ pageContext, ...props }) => {
  return (
    <LeifArticleTemplate
      {...safelyGetFrontMatter(pageContext)}
      {...props}
      isPreview={false}
    />
  )
}

export default LeifArticle
